import Enumerable from "linq";
import { Table } from "element-ui";

// ElementUIにない機能を後付で実装するユーティリティクラス.
// 内部のDOM構造を勝手に参照してる実装があるのでElementUIのバージョンアップ時は注意する事.
// (非公開の内部のDOM構造を参照してるので動かなくなる可能性は少なくないです.)
export class ElementUiUtility {
  static getColumnWidths(source: Table): number[] {
    const colGroup = source.$el.querySelector(".el-table__header-wrapper > table > colgroup") as HTMLTableColElement; // ColgroupもHTMLTableColElementらしい.
    return Enumerable.from(colGroup ? colGroup.getElementsByTagName("col") : [])
      .cast<HTMLTableColElement>()
      .select(c => Number(c.width)) // HTMLTableColElementはdeprecatd(非推奨)らしいがElementUIが使ってるので使う.
      .toArray();
  }
}
